<template>
    <div class="wrap">
        <div style="display:block;align-items:center;gap:10px;margin-bottom: 200px;">

            <div>
                <span class="shopData">{{ $route.query.name }}</span>


                <span style="margin-left: 50px;">所在地:{{ $route.query.addr }} </span>
            </div>


            <div v-if="!verifySuccess">
                <h3 class="modal-title">请输入验证码查看店铺资质证照</h3>
                <div style="display: flex;">
                    <el-input v-model="inputCode" class="input-code" placeholder="请输入验证码" @input="handleInput" />

                    <canvas ref="canvasRef" width="100" height="30" @click="generateCode"
                        style="height:50px;cursor:pointer;border:1px solid #ccc;"></canvas>

                </div>

                <div class="tip-text" v-if="showError">验证码不正确，请重新输入</div>

                <br><br>

                <button class="con11" @click="checkCode">确认</button>


            </div>




            <!-- 验证成功展示营业执照 -->
            <div class="license-box" v-if="verifySuccess">
                <p style="margin: 15px 0 8px; font-size:14px;">营业执照：</p>
                <a href="http://www.maxrong.com/yyzz.png" target="\_blank">
                    <img class="license-img" src="http://www.maxrong.com/yyzz.png" alt="营业执照" />
                </a>
            </div>

        </div>
    </div>


</template>

<script>

export default {

    data() {
        return {
            inputCode: '',
            code: '',


            // 弹窗状态
            showModal: false,

            showError: false,
            verifySuccess: false,
        }
    },
    mounted() {
        this.generateCode()
    },

    methods: {

        collect() {
            if (this.collectData.ifCollect === 0) {
                let params = {
                    url: api.collect,
                    method: 'POST',
                    data: {
                        shopId: this.collectData.shopId
                    }
                }
                this.sendReq(params, res => {
                    if (res.code === '200') {
                        let data = {
                            shopName: this.collectData.shopName,
                            shopAdress: this.collectData.shopAdress,
                            collectId: this.collectData.collectId,
                            ifCollect: 1,
                            classifyNumber: res.data.classifyNumber,
                            number: res.data.number,
                            shopLogo: res.data.shopLogo
                        }
                        this.setCollectData(data)
                        this.$message.success('收藏成功')
                    }
                })
            } else {
                let params = {
                    url: api.unfavorite,
                    method: 'PUT',
                    data: {
                        ids: [this.collectData.collectId]
                    }
                }
                this.sendReq(params, res => {
                    if (res.code === '200') {
                        let data = {
                            shopName: this.collectData.shopName,
                            shopAdress: this.collectData.shopAdress,
                            collectId: this.collectData.collectId,
                            ifCollect: 0,
                            classifyNumber: res.data.classifyNumber,
                            number: res.data.number,
                            shopLogo: res.data.shopLogo
                        }
                        this.setCollectData(data)
                        this.$message.success('取消成功')
                    }
                })
            }
        },


        handleInput() {
            this.showError = false;
        },

        checkCode() {

            const ccc = this.inputCode.trim()

            if (ccc === this.code) {
                this.showError = false
                this.verifySuccess = true
            } else {
                this.showError = true
                this.verifySuccess = false
            }
        },


        // 随机数字
        randomNum() {
            return String(Math.floor(Math.random() * 10))
        },
        // 随机rgb颜色
        randomColor(min = 0, max = 255) {
            const r = Math.floor(Math.random() * (max - min) + min)
            const g = Math.floor(Math.random() * (max - min) + min)
            const b = Math.floor(Math.random() * (max - min) + min)
            return `rgb(${r},${g},${b})`
        },
        // 生成并绘制验证码
        generateCode() {
            const canvas = this.$refs.canvasRef
            const ctx = canvas.getContext('2d')
            const w = canvas.width
            const h = canvas.height

            // 背景
            ctx.fillStyle = this.randomColor(180, 240)
            ctx.fillRect(0, 0, w, h)

            // 生成4位数字
            this.code = ''
            for (let i = 0; i < 4; i++) {
                this.code += this.randomNum()
            }

            // 干扰线
            for (let i = 0; i < 4; i++) {
                ctx.strokeStyle = this.randomColor(80, 180)
                ctx.beginPath()
                ctx.moveTo(Math.random() * w, Math.random() * h)
                ctx.lineTo(Math.random() * w, Math.random() * h)
                ctx.stroke()
            }

            // 噪点
            for (let i = 0; i < 40; i++) {
                ctx.fillStyle = this.randomColor(50, 200)
                ctx.beginPath()
                ctx.arc(Math.random() * w, Math.random() * h, 1, 0, Math.PI * 2)
                ctx.fill()
            }

            // 绘制数字，随机倾斜
            ctx.font = 'bold 22px Arial'
            for (let i = 0; i < this.code.length; i++) {
                ctx.save()
                ctx.fillStyle = this.randomColor(0, 100)
                const x = 10 + i * 24
                const y = 24
                const rotate = (Math.random() - 0.5) * 0.6
                ctx.translate(x, y)
                ctx.rotate(rotate)
                ctx.fillText(this.code[i], 0, 0)
                ctx.restore()
            }
        },

    }
}
</script>


<style scoped>
.modal-title {
    margin-top: 20px;
    font-size: 17px;
    margin-bottom: 16px;
}

.input-code {
    width: 60%;
    padding: 12px;
    font-size: 15px;
}

.modal-btns {
    display: flex;
    gap: 10px;
}


.con11 {
    margin-top: 10px;
    width: 350px;
    padding: 11px;
    border-radius: 6px;
    border: none;
    font-size: 15px;
    cursor: pointer;
    width: 350px;
    background: #2563eb;
    color: #fff;
}


.license-img{
    width: 800px;

}


.tip-text {
    margin: 10px 0;
    color: #f03838;
    font-size: 14px;
}

.license-box {
    margin-top: 15px;
}



.box {
    border: 1px solid #eee;
    border-radius: 6px;
    background-color: #eee;
    font-size: 24px;
    height: 50px;
    line-height: 50px;
    width: 100px;
    padding-left: 10px;


}

.wrap {
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
}


.shopData {
    font-family: "SimHei", "黑体", sans-serif;
    margin-top: 40px;
    font-size: 40px;
    color: #333333;
    margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/new/yyzz.vue